export default __webpack_public_path__ + "media/images/89-ecec76c0865e0624601c1f9609884ed3.jpg";